import {FormInstance} from 'antd/es/form';

import {TFieldPath} from 'components/report-configuration/report-configuration.types';

interface IUndefineTypeDependentFieldsArgs {
    form: FormInstance;
    fieldsPaths: TFieldPath[];
}

export const undefineTypeDependentFields = ({
    form,
    fieldsPaths,
}: IUndefineTypeDependentFieldsArgs) => {
    const updatedFieldsValues = fieldsPaths.map(path => ({
        name: path,
        value: undefined,
    }));
    form.setFields([
        ...updatedFieldsValues,
    ]);
};
